export default __webpack_public_path__ + "static/media/equipar_item_02.ec5d883c.mp3";